import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import RegisterForm from '../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Create an Account
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Sign up to access exclusive features and track your orders
        </Typography>
      </Box>
      
      <RegisterForm />
      
      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Already have an account?{' '}
          <Link component={RouterLink} to="/login" color="primary">
            Login here
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default RegisterPage; 